module.exports = ".input-diferent-select {\n    color: red\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cliente/registro-cliente/direccion-cliente/direccion-cliente.component.css
// module id = ./src/app/components/cliente/registro-cliente/direccion-cliente/direccion-cliente.component.css
// module chunks = main